export const experiences = [
  {
    isCurrent: true,
    summary:
      "Full-stack developer working with Angular and Java. Working for the iShares platform",
    title: "Associate Software Developer",
    startDate: {
      month: 11,
      year: 2017
    },
    company: {
      name: "BlackRock"
    }
  },
  {
    isCurrent: false,
    summary:
      "Full-stack developer working with Angular, Node and TypeScript. Working for the iShares platform. Emphasis on Dev-ops and developing the continous integration pipeline.",
    title: "Software Developer",
    endDate: {
      month: 11,
      year: 2017
    },
    startDate: {
      month: 10,
      year: 2016
    },
    company: {
      name: "Torch Markets"
    }
  },
  {
    isCurrent: false,
    summary:
      "Used ASP.NET MVC 5 to produce a diversity data collection tool for the future of British television.\n\nUsed AngularJS and C# best practices. Technologies used include JavaScript, ASP.NET MVC 5, SQL, Oracle, SASS, Bootstrap, Grunt.",
    title: "Software Developer",
    endDate: {
      month: 10,
      year: 2016
    },
    startDate: {
      month: 3,
      year: 2015
    },
    company: {
      name: "Soundmouse"
    }
  },
  {
    isCurrent: false,
    summary:
      "Develop web commerce platforms for constious high profile clients.\n\nCreated a log analysis web application with the Play Framework in Java, incorporating Test Driven Development. It asynchronously uploads and processes large (2 GB) log files, and outputs meaningful results in context with the problem. \n\nAnalysis  and  development  of  the payment system infrastructure and user accounts section to be used by several clients of the company such as Waitrose, Tally Weijl, DJ Sports, Debenhams, Ann Summers, John Lewis and others.\n\nTechnologies used include WebSphere Commerce, Java, JavaScript and JSP.",
    title: "Java Developer",
    endDate: {
      month: 10,
      year: 2014
    },
    startDate: {
      month: 3,
      year: 2013
    },
    company: {
      name: "Soundmouse"
    }
  }
];

export const education = [
  {
    degree: "Master of Science (MSc)",
    fieldOfStudy: "Computer Science",
    notes:
      "Exam Results: 1st Class with Distinction, Dissertation: 1st Class with Distinction\n\nRelevant Courses: Java and C# Programming, Software Engineering, Artificial Intelligence, \nComputational Photography, Algorithmics, Architecture and Hardware.\n\nCreated a Windows 8 game in JavaScript for the dissertation. \n\nCreated an award-winning 3D stereoscopic game in C# using XNA.",
    schoolName: "University College London",
    startDate: {
      year: 2012
    },
    endDate: {
      year: 2013
    }
  },
  {
    degree: "Bachelor of Engineering (BEng)",
    fieldOfStudy: "Material Science and Engineering",
    notes:
      "Exam Results: 2:1, Dissertation: 1st Class with Distinction\n\nRelevant courses: C Programming, Mathematics and Business for Engineers.",
    schoolName: "Imperial College London",
    startDate: {
      year: 2009
    },
    endDate: {
      year: 2012
    }
  }
];

export const skills = [
  {
    name: "Angular"
  },
  {
    name: "TypeScript"
  },
  {
    name: "JavaScript"
  },
  {
    name: "NodeJS"
  }
];

export const achievements = [
  {
    issuer: "Oracle",
    name: "Oracle Certified Expert"
  }
];
